import { render, staticRenderFns } from "./top_up.vue?vue&type=template&id=24b72e86&scoped=true&"
import script from "./top_up.vue?vue&type=script&lang=js&"
export * from "./top_up.vue?vue&type=script&lang=js&"
import style0 from "./top_up.vue?vue&type=style&index=0&id=24b72e86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b72e86",
  null
  
)

export default component.exports